import React from 'react';

// Food item SVG components - cute pixel/chibi style
// Each accepts size (default 40) and optional className

export function PetKibbleSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="12" width="24" height="18" rx="4" fill="#8B6940" />
      <rect x="10" y="14" width="20" height="3" rx="1" fill="#A0825A" />
      <circle cx="15" cy="22" r="2" fill="#6B5030" />
      <circle cx="25" cy="22" r="2" fill="#6B5030" />
      <circle cx="20" cy="25" r="2" fill="#6B5030" />
      <text x="20" y="10" textAnchor="middle" fontSize="8" fill="#8B6940" fontWeight="bold">KIBBLE</text>
    </svg>
  );
}

export function PremiumChowSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="14" width="24" height="16" rx="3" fill="#FFB300" />
      <rect x="10" y="16" width="20" height="3" rx="1" fill="#FFD54F" />
      <path d="M16 24L20 20L24 24" stroke="#F57F17" strokeWidth="2" strokeLinecap="round" />
      <circle cx="20" cy="8" r="4" fill="#FFD54F" />
      <text x="20" y="10" textAnchor="middle" fontSize="5" fill="#F57F17" fontWeight="bold">★</text>
    </svg>
  );
}

export function FreshFishSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="18" cy="20" rx="12" ry="7" fill="#64B5F6" />
      <polygon points="30,20 38,14 38,26" fill="#42A5F5" />
      <circle cx="12" cy="18" r="1.5" fill="#1565C0" />
      <path d="M14 23Q18 26 22 23" stroke="#1565C0" strokeWidth="1" fill="none" />
    </svg>
  );
}

export function JuicySteakSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="20" cy="22" rx="14" ry="10" fill="#8D6E63" />
      <ellipse cx="20" cy="20" rx="12" ry="8" fill="#D7837F" />
      <path d="M12 18C14 16 18 15 22 16C26 17 28 19 28 20" stroke="#C62828" strokeWidth="1.5" fill="none" />
      <rect x="18" y="28" width="4" height="8" rx="1" fill="#5D4037" />
    </svg>
  );
}

export function BambooTreatSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="16" y="4" width="8" height="32" rx="3" fill="#66BB6A" />
      <rect x="16" y="10" width="8" height="2" fill="#43A047" />
      <rect x="16" y="18" width="8" height="2" fill="#43A047" />
      <rect x="16" y="26" width="8" height="2" fill="#43A047" />
      <path d="M24 8L30 5L28 10Z" fill="#81C784" />
      <path d="M16 16L10 13L12 18Z" fill="#81C784" />
    </svg>
  );
}

export function HoneyDropsSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6L26 18C28 22 26 28 20 28C14 28 12 22 14 18L20 6Z" fill="#FFB300" />
      <ellipse cx="20" cy="22" rx="5" ry="4" fill="#FFD54F" opacity="0.6" />
      <circle cx="18" cy="20" r="1" fill="#FFF" opacity="0.5" />
      <path d="M14 32L20 30L26 32" stroke="#F57F17" strokeWidth="1.5" fill="none" />
    </svg>
  );
}

export function SweetBerriesSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="24" r="6" fill="#E53935" />
      <circle cx="26" cy="24" r="6" fill="#E53935" />
      <circle cx="20" cy="18" r="6" fill="#EF5350" />
      <circle cx="13" cy="22" r="1" fill="#FFCDD2" />
      <circle cx="21" cy="16" r="1" fill="#FFCDD2" />
      <circle cx="27" cy="22" r="1" fill="#FFCDD2" />
      <path d="M18 12L20 6L22 12" stroke="#43A047" strokeWidth="1.5" fill="none" />
      <ellipse cx="20" cy="8" rx="3" ry="2" fill="#66BB6A" />
    </svg>
  );
}

export function CrystalCandySvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="20,4 28,14 28,26 20,36 12,26 12,14" fill="#81D4FA" />
      <polygon points="20,8 25,15 25,25 20,32 15,25 15,15" fill="#B3E5FC" opacity="0.6" />
      <line x1="20" y1="4" x2="20" y2="36" stroke="#4FC3F7" strokeWidth="0.5" />
      <line x1="12" y1="20" x2="28" y2="20" stroke="#4FC3F7" strokeWidth="0.5" />
      <circle cx="18" cy="16" r="1.5" fill="#FFF" opacity="0.7" />
    </svg>
  );
}

export function DragonFruitSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="20" cy="22" rx="12" ry="10" fill="#E91E63" />
      <ellipse cx="20" cy="22" rx="8" ry="7" fill="#FCE4EC" />
      <circle cx="16" cy="20" r="1" fill="#333" />
      <circle cx="20" cy="22" r="1" fill="#333" />
      <circle cx="24" cy="20" r="1" fill="#333" />
      <circle cx="18" cy="24" r="1" fill="#333" />
      <circle cx="22" cy="24" r="1" fill="#333" />
      <path d="M14 12L20 6L26 12" stroke="#66BB6A" strokeWidth="2" fill="#81C784" />
    </svg>
  );
}

export function CarrotCakeSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="16" width="24" height="16" rx="3" fill="#FFCC80" />
      <rect x="8" y="16" width="24" height="5" rx="2" fill="#FFF8E1" />
      <path d="M18 10L20 4L22 10" stroke="#66BB6A" strokeWidth="1.5" fill="none" />
      <rect x="19" y="8" width="2" height="8" rx="1" fill="#FF8A65" />
    </svg>
  );
}

export function SeaweedWrapSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="10" width="20" height="20" rx="4" fill="#2E7D32" />
      <rect x="12" y="12" width="16" height="16" rx="2" fill="#FFF8E1" />
      <circle cx="17" cy="20" r="2" fill="#FF8A65" />
      <circle cx="23" cy="20" r="2" fill="#66BB6A" />
      <rect x="18" y="16" width="4" height="8" rx="1" fill="#FFCC80" />
    </svg>
  );
}

export function MushroomStewSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="20" cy="26" rx="12" ry="6" fill="#8D6E63" />
      <ellipse cx="20" cy="24" rx="10" ry="5" fill="#D7CCC8" />
      <ellipse cx="20" cy="23" rx="8" ry="3" fill="#A1887F" opacity="0.5" />
      <path d="M16 14C16 10 18 8 20 8C22 8 24 10 24 14" fill="#E53935" />
      <rect x="19" y="14" width="2" height="8" fill="#8D6E63" />
      <circle cx="18" cy="12" r="1" fill="#FFCDD2" />
    </svg>
  );
}

// Lookup map
export const FOOD_COMPONENTS = {
  pet_kibble: PetKibbleSvg,
  premium_chow: PremiumChowSvg,
  fresh_fish: FreshFishSvg,
  juicy_steak: JuicySteakSvg,
  bamboo_treat: BambooTreatSvg,
  honey_drops: HoneyDropsSvg,
  sweet_berries: SweetBerriesSvg,
  crystal_candy: CrystalCandySvg,
  dragon_fruit: DragonFruitSvg,
  carrot_cake: CarrotCakeSvg,
  seaweed_wrap: SeaweedWrapSvg,
  mushroom_stew: MushroomStewSvg,
};

export function getFoodComponent(foodId) {
  return FOOD_COMPONENTS[foodId] || PetKibbleSvg;
}

// Food metadata for display
export const FOOD_CATALOG = [
  { id: 'pet_kibble', name: 'Pet Kibble', price: 0, uses: 5, desc: '+15 hunger. Auto-granted hourly.' },
  { id: 'premium_chow', name: 'Premium Chow', price: 25, uses: 5, desc: '+25 hunger, +5 happiness.' },
  { id: 'fresh_fish', name: 'Fresh Fish', price: 20, uses: 3, desc: 'Favorite: cats, foxes, ocelots.' },
  { id: 'juicy_steak', name: 'Juicy Steak', price: 20, uses: 3, desc: 'Favorite: wolves, bears.' },
  { id: 'bamboo_treat', name: 'Bamboo Treat', price: 20, uses: 3, desc: 'Favorite: pandas.' },
  { id: 'honey_drops', name: 'Honey Drops', price: 15, uses: 3, desc: 'Favorite: bees, bears.' },
  { id: 'sweet_berries', name: 'Sweet Berries', price: 15, uses: 3, desc: 'Favorite: foxes, rabbits.' },
  { id: 'crystal_candy', name: 'Crystal Candy', price: 25, uses: 3, desc: 'Favorite: slimes.' },
  { id: 'dragon_fruit', name: 'Dragon Fruit', price: 30, uses: 3, desc: 'Favorite: dragons.' },
  { id: 'carrot_cake', name: 'Carrot Cake', price: 15, uses: 3, desc: 'Favorite: rabbits, horses.' },
  { id: 'seaweed_wrap', name: 'Seaweed Wrap', price: 20, uses: 3, desc: 'Favorite: axolotl, turtle.' },
  { id: 'mushroom_stew', name: 'Mushroom Stew', price: 15, uses: 3, desc: 'Favorite: cows, sheep.' },
];
